/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Wealthlane_AwardService_EsppAwards_Constants_OfferingPeriodType {
    '_1' = 1,
    '_2' = 2,
}
